import { defineMessages } from 'react-intl';

const messages = defineMessages({
  assetsFiltersAudio: {
    id: 'assetsFiltersAudio',
    defaultMessage: 'Audio',
    description: 'Label for audio file types',
  },
  assetsFiltersCode: {
    id: 'assetsFiltersCode',
    defaultMessage: 'Code',
    description: 'Label for code file types',
  },
  assetsFiltersDocuments: {
    id: 'assetsFiltersDocuments',
    defaultMessage: 'Document',
    description: 'Label for document file types',
  },
  assetsFiltersImages: {
    id: 'assetsFiltersImages',
    defaultMessage: 'Image',
    description: 'Label for image file types',
  },
  assetsFiltersOther: {
    id: 'assetsFiltersOther',
    defaultMessage: 'Other',
    description: 'Label for other file types',
  },
  assetsFiltersSectionLabel: {
    id: 'assetsFiltersSectionLabel',
    defaultMessage: 'Filter by File Type',
    description: 'Label for the filter section of the page',
  },
});

export default messages;
